module.exports = __webpack_public_path__ + "static/media/bell.4604a846.svg";